<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">
      <el-form-item label="申请部门:" v-if="form.type=='0'">
        {{form.department.name}}
      </el-form-item>
      <el-form-item label="申请单位:" v-else>
        {{form.department.name}}
      </el-form-item>
      <el-form-item label="申请人:">
        <user-info :userData='form.creator'></user-info>
      </el-form-item>
      <el-form-item label="申请时间:">
        {{ getTime(form.flow.createTime) }}
      </el-form-item>
      <el-form-item label="采购项目:">
        {{ form.name }}
      </el-form-item>
      <el-form-item class="full" label="采购内容:">
        <div class="material-table">
          <el-table :data="form.purchaseRecordItems" border>
            <el-table-column prop="name" label="采购名称">
            </el-table-column>
            <el-table-column prop="spec" label="规格型号">
            </el-table-column>
            <el-table-column prop="amount" align="center" label="成交数量">
            </el-table-column>
            <el-table-column prop="price" label="成交单价">
            </el-table-column>
            <el-table-column prop="fee" align="center" label="成交金额">
            </el-table-column>
            <el-table-column prop="ghdw" align="center" label="供货单位">
            </el-table-column>
          </el-table>
        </div>
        <div class="total-price">
          总价：<span>{{ total }}</span> &nbsp;&nbsp;&nbsp;&nbsp;大写金额：<span>{{ form.price }}</span>
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      total: function () {
        var _total = 0
        for (var i = 0; i < this.form.purchaseRecordItems.length; i++) {
          var _item = this.form.purchaseRecordItems[i]
          _total += _item.fee / 1
        }
        return _total.toFixed(2)
      }
    },
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(t) {
        return util.getFormatDate(t, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/purchase/components/purchaseRecordDetail.vue